import React from 'react';
import PropTypes from 'prop-types';
import { Field, withFormik } from 'formik';
import {
  CheckboxGroup,
  CheckboxWrapper,
  FormLayout,
  GridItem,
  GridContainer,
} from '../../common';

const DEFAULT_VALUES = {
  allergy: true,
  diagnosis: true,
  diet: true,
  emergencyContact: true,
  insurance: true,
  otherContact: true,
  patient: {
    isIncluded: true,
    gender: true,
    birthday: true,
    address: true,
  },
  pharmacy: true,
  prescription: true,
  primaryCaregiver: {
    isIncluded: true,
    address: true,
    phone: true,
    email: true,
  },
  primaryCareProvider: true,
  specialist: true,
  surgery: true,
};

function PDFSettingsForm(props) {
  const { pdfFields, values, setFieldValue } = props;
  return (
    <FormLayout {...props} submitButtonText="Download">
      <GridContainer spacing={24}>
        {pdfFields.map(pdfField => (
          <React.Fragment key={pdfField.id}>
            <GridItem xs={12}>
              {pdfField.subfields ? (
                <CheckboxGroup
                  checkboxField={pdfField}
                  setFieldValue={setFieldValue}
                  values={values[pdfField.id]}
                />
              ) : (
                <Field
                  component={CheckboxWrapper}
                  id={pdfField.id}
                  key={pdfField.id}
                  label={pdfField.label}
                  name={pdfField.id}
                />
              )}
            </GridItem>
          </React.Fragment>
        ))}
      </GridContainer>
    </FormLayout>
  );
}

PDFSettingsForm.propTypes = {
  onGeneratePdf: PropTypes.func.isRequired,
  pdfFields: PropTypes.array.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default withFormik({
  displayName: 'PDFSettingsForm',
  handleSubmit: (values, { props, setStatus }) =>
    props.onGeneratePdf(values).catch(error => setStatus({ saveError: error })),
  mapPropsToValues: () => {
    return DEFAULT_VALUES;
  },
})(PDFSettingsForm);



// WEBPACK FOOTER //
// ./src/modules/PDFSettingsPage/components/PDFSettingsForm.js